import { isWorkplaceLayerBDmKind } from "@/lib/messages/workplaceLayerModel";
import type { ThreadRow } from "./workplaceMessagesTypes";

export type WorkplaceWorkflowNotificationsPanelProps = {
  threads: ThreadRow[];
  loadingList: boolean;
  allowTestNotification: boolean;
  testBusy: boolean;
  onTest: () => void;
  onSelectThread: (threadId: string) => void;
  selectedThreadId: string | null;
};

/** Layer A workflow rows in the bell (checklist nudge, tasks, etc.) — not vendor DMs. */
export function WorkplaceWorkflowNotificationsPanel(p: WorkplaceWorkflowNotificationsPanelProps) {
  const workflowThreads = p.threads.filter((t) => !isWorkplaceLayerBDmKind(String(t.latest_message?.kind || "")));

  return (
    <div className="text-left text-sm text-gray-800 dark:text-gray-100">
      {p.allowTestNotification ? (
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            disabled={p.testBusy}
            onClick={() => void p.onTest()}
            className="rounded-lg border border-gray-300 bg-gray-50 px-2.5 py-1 text-[11px] font-medium text-gray-800 hover:bg-gray-100 disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-800 dark:text-gray-100 dark:hover:bg-zinc-700"
          >
            {p.testBusy ? "Sending…" : "Send test notification"}
          </button>
        </div>
      ) : null}
      {p.loadingList ? (
        <p className="mt-2 text-xs text-gray-500">Loading workflow notifications…</p>
      ) : workflowThreads.length === 0 ? (
        <p className="mt-2 text-xs text-gray-500">
          No unread workflow notifications. Team chat unread shows on Firefly Messages, not this bell.
        </p>
      ) : (
        <ul className="mt-2 max-h-36 divide-y divide-gray-100 overflow-y-auto rounded-xl border border-gray-200 dark:divide-zinc-700 dark:border-zinc-700">
          {workflowThreads.map((t) => (
            <li key={t.thread_id}>
              <button
                type="button"
                onClick={() => p.onSelectThread(t.thread_id)}
                className={`w-full px-2.5 py-2 text-left text-xs hover:bg-gray-50 dark:hover:bg-zinc-800 ${
                  p.selectedThreadId === t.thread_id ? "bg-blue-50 dark:bg-zinc-800" : ""
                }`}
              >
                <div className="font-medium">{t.latest_message.title}</div>
                <div className="text-[11px] text-gray-500 dark:text-gray-400 line-clamp-1">{t.latest_message.body}</div>
                <div className="text-[10px] text-gray-500 dark:text-gray-400">
                  {t.unread_count} unread · {String(t.latest_message.kind || "notification")}
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
